<template>
    <div class="t-lk-modal__content t-lk-refuse-lead__container">
        <h2 class="t-lk-modal__title">{{ $root.staticText.lk.leadsReasonTitle }}</h2>
        <div class="t-lk-modal__text">
            {{ $root.staticText.lk.leadsViewDeleteContact }}
        </div>

        <div class="t-lk-refuse-lead__row">
            <div
                class="t-lk-refuse-lead__yes t-btn _lk"
                :class="{_disabled: disabledBtn}"
                @click="submit"
            >
                {{ $root.staticText.forms.yes }}
            </div>
            <div class="t-lk-refuse-lead__cancel t-btn _lk _border-gray" @click="modalClose">
                {{ $root.staticText.forms.no }}
            </div>
        </div>
    </div>
</template>

<script>
    import selectCustom from '@components/ui-components/select-custom/select-custom-dynamic-input.vue';
    import { mapActions } from "vuex";
    import Vue from "vue";

    export default {
        name: "refuse-lead",
        props: ['props'],
        data() {
            return {
                action: "lk/leads/deleteContact",
                disabledBtn: false,
            }
        },
        components: {
            'select-custom-cmp': selectCustom,
        },
        methods: {
            ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),

            submit() {
                this.disabledBtn = true;
                let fd = new FormData();
                fd.append('leadId', this.props.leadId);
                fd.append('contactId', this.props.contactId);

                Vue.http.post(this.action, fd)
                    .then(response => response.json())
                    .then(data => {
                        this.disabledBtn = false;
                        if (data.success) {
                            this.$router.go(0);
                            // this.modalClose();
                            // this.modalType_lkSuccessOpen({
                            //     title: this.$root.staticText.lk.successTitle,
                            //     closeBthNone: true
                            // });
                            // this.$parent.$parent.$children[3].$children[0].updateData()

                        } else {
                            this.openError(data);
                        }
                    })
                    .catch(data => {
                        this.disabledBtn = false;
                        this.openError(data);
                    });
            },
            openError(data) {
                let text = this.$root.staticText.lk.lkErrorText;
                if (data.errors && data.errors.length > 0) {
                    let key = Object.keys(data.errors)[0];
                    if (data.errors[key][0]) {
                        text = data.errors[key][0];
                    }
                }
                this.modalType_lkErrorOpen({
                    title: this.$root.staticText.lk.lkErrorTitle,
                    text: text,
                    closeBthNone: true
                });
            },
        },
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/delete-contact.vue